import React, { ReactNode } from 'react';

import styled from '@emotion/styled';
import { ITheme } from '../../../../../ui';
import { Amenity } from '../../../domain/models/Amenity';
import { AmenityIcon } from '../../shared/icons/AmenityIcon';
import themed from '../../../../../ui/themer/themed';

interface IAmenityButtonProps {
	amenity: Amenity;
	selected: boolean;
	onToggle: () => void;
	children?: ReactNode;
}

export const AmenityButton = ({
	amenity,
	selected,
	onToggle,
	children,
}: IAmenityButtonProps) => (
	<StyledAmenityButton
		dimmed={!selected}
		title={amenity}
		onClick={onToggle}
		aria-current={selected}
	>
		<AmenityIcon amenity={amenity} />
		{children && children}
	</StyledAmenityButton>
);

const StyledAmenityButton = styled.button<{ dimmed: boolean }, ITheme>`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 0 8px;
	cursor: pointer;
	background: none;
	border: none;
	font-family: ${themed(({ typography }) => typography.body.fontFamily)};

	svg {
		filter: grayscale(${(p) => (p.dimmed ? 100 : 0)}%);
		opacity: ${(p) => (p.dimmed ? 0.6 : 1)};
	}
`;
